import React from 'react';
import { X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';

const formatDate = (dateString) => {
  if (!dateString) return '';
  try {
    return format(new Date(dateString), 'PPP', { locale: es });
  } catch (e) {
    return dateString;
  }
};

const formatValue = (field, value) => {
  if (!value) return '';
  
  // Verificar si es un rango de fechas (por type o filterType)
  if (field.type === 'daterange' || field.filterType === 'daterange') {
    const from = value.$gte ? new Date(value.$gte) : null;
    const to = value.$lte ? new Date(value.$lte) : null;
    
    if (from && to) {
      return `${format(from, 'd MMM yyyy', { locale: es })} - ${format(to, 'd MMM yyyy', { locale: es })}`;
    } else if (from) {
      return `Desde ${format(from, 'd MMM yyyy', { locale: es })}`;
    } else if (to) {
      return `Hasta ${format(to, 'd MMM yyyy', { locale: es })}`;
    }
  }
  
  if (field.type === 'select') {
    const option = field.options?.find(opt => opt.value === value);
    return option?.label || value;
  }
  
  return value.toString();
};

const AppliedFilters = ({ filters, fields, onRemoveFilter }) => {
  if (!filters || Object.keys(filters).length === 0) {
    return null;
  }

  // Si no hay fields definidos, no mostrar filtros aplicados
  if (!fields || !Array.isArray(fields)) {
    return null;
  }

  const getFieldById = (id) => fields?.find(field => field.id === id || field.key === id);

  return (
    <div className="flex flex-wrap gap-2 mb-4">
      {Object.entries(filters).map(([key, value]) => {
        if (!value) return null;
        
        // Manejar rangos de fechas
        if (typeof value === 'object' && (value.$gte || value.$lte)) {
          const field = getFieldById(key);
          if (!field) return null;
          
          return (
            <div 
              key={key}
              className="inline-flex items-center gap-2 px-3 py-1 text-sm font-medium rounded-full border border-border bg-background text-foreground shadow-sm"
            >
              <span className="font-semibold">{field.label}:</span>
              <span>{formatValue(field, value)}</span>
              <Button
                variant="ghost"
                size="icon"
                className="h-5 w-5 p-0 rounded-full hover:bg-muted text-muted-foreground hover:text-foreground"
                onClick={(e) => {
                  e.stopPropagation();
                  onRemoveFilter(key);
                }}
                aria-label={`Eliminar filtro de ${field.label}`}
              >
                <X className="h-3.5 w-3.5" />
              </Button>
            </div>
          );
        }
        
        // Manejar otros tipos de filtros
        const field = getFieldById(key);
        if (!field) return null;
        
        return (
          <div 
            key={key}
            className="inline-flex items-center gap-2 px-3 py-1 text-sm font-medium rounded-full border border-border bg-background text-foreground shadow-sm"
          >
            <span className="font-semibold">{field.label}:</span>
            <span>{formatValue(field, value)}</span>
            <Button
              variant="ghost"
              size="icon"
              className="h-5 w-5 p-0 rounded-full hover:bg-muted text-muted-foreground hover:text-foreground"
              onClick={(e) => {
                e.stopPropagation();
                onRemoveFilter(key);
              }}
              aria-label={`Eliminar filtro de ${field.label}`}
            >
              <X className="h-3.5 w-3.5" />
            </Button>
          </div>
        );
      })}
    </div>
  );
};

export default AppliedFilters;
